import PropTypes from "prop-types";
import React from "react";
import DataGrid, { DataGridItem } from "components/data-grid";
import { injectIntl } from "react-intl";
import OptionalDate from "components/optional-date";
import { LinkWithIcon } from "components/link";
import {differenceInDays} from "date-fns";
import Icon from "../../../components/icon/icon";
import styles from "./styles.css.js";
import withStyles from "../../../components/with-styles/with-styles";
import {RECORDING_EXPIRATION_WARNING_DAYS, RECORDING_EXPIRATION_WARNING_DAYS_MAX} from "../../../utils/constants";

const RecordingData = ({ recording, intl, classes }) => {

  const formattedDays = recording?.expirationDate && differenceInDays(recording?.expirationDate * 1000, new Date());

    const expirationWarningText = intl.formatMessage(
        { id: "recording.expiration.warning" },
        {
            days: formattedDays
        },
    );

  return !recording ? null : (
    <DataGrid>
      <DataGridItem big>
        {recording.deployment && (
          <LinkWithIcon
            text={recording.deployment.codename}
            iconName="settings-input-antenna"
            color="primary"
            href={`/deployment/details/${recording.deployment ? recording.deployment.id : null}`}
          />
        )}
      </DataGridItem>
      <DataGridItem extraSmall>
        <OptionalDate
          className={classes}
          label={intl.formatMessage({ id: "common.created" })}
          value={recording.created ? recording.created * 1000 : null}
          icon="event-available"
        />
      </DataGridItem>
      <DataGridItem extraSmall>
        <LinkWithIcon
          label={intl.formatMessage({ id: "recording.event" })}
          text={recording.event ? recording.event.title : null}
          iconName="event-available"
          color="primary"
          href={`/event/details/${recording.eventId}/customer/${recording.customerId}`}
        />
      </DataGridItem>
      <DataGridItem extraSmall>
        <OptionalDate
          label={intl.formatMessage({ id: "event.startDate" })}
          value={recording.event ? recording.event.startDate : null}
        />
      </DataGridItem>
      <DataGridItem extraSmall>
        <OptionalDate
          label={intl.formatMessage({ id: "event.endDate" })}
          value={recording.event ? recording.event.endDate : null}
        />
      </DataGridItem>
      {recording?.expirationDate && <DataGridItem extraSmall>
        <OptionalDate
           withTime={false}
           label={intl.formatMessage({id: "recording.expiration.date"})}
           value={recording?.expirationDate * 1000}
        />
        {formattedDays <= RECORDING_EXPIRATION_WARNING_DAYS && <div className={classes.container}>
           <Icon color={"secondary"} name="ErrorOutlineRoundedIcon"/>
           <div className={classes.warningText}>{formattedDays <= RECORDING_EXPIRATION_WARNING_DAYS_MAX ? intl.formatMessage({id: 'recording.expiration.warning.delete'}) : expirationWarningText}</div>
        </div>}
        </DataGridItem>}
    </DataGrid>
  );
};

RecordingData.propTypes = {
  /**
   * Data to represent
   **/
  recording: PropTypes.object,
};

export default withStyles(styles)(injectIntl(RecordingData));
